import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative h-[420px] md:h-[550px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dark%20city%20nightscape%20with%20flowing%20cyber%20energy%20waves%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20elegant%20artistic%20composition%2C%20dark%20dramatic%20sky%20with%20golden%20glow%2C%20sophisticated%20modern%20aesthetic&width=1800&height=700&seq=cta-section-bg&orientation=landscape"
        alt="吃瓜黑料网 - 爆料不打烊"
        title="吃瓜黑料网CTA"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative h-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto h-full flex items-center">
          <div className="w-full flex flex-col md:flex-row md:items-end justify-between gap-8">
            <div className="md:pb-10">
              <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-background-50 leading-none">
                爆料
                <br />
                不打烊
              </h2>
              <Link
                to="/about"
                className="inline-flex items-center gap-3 mt-6 px-6 py-3 rounded-full bg-background-50 text-foreground-900 text-sm font-medium hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer group"
              >
                <span>立即投稿</span>
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 group-hover:bg-primary-500 transition-colors">
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </Link>
            </div>

            <div className="md:pb-10 md:text-right max-w-sm">
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed">
                你手里有料，我们帮你曝光。
              </p>
              <p className="text-sm md:text-base text-background-50/60 leading-relaxed mt-1">
                所有爆料严格保密，信息经核实后第一时间发布。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}